app.bind('default', function (context) {
    $('[js-billboard]', context).each(function () {
        const $billboard = $(this);
        const autoplay = $(this).data('autoplay') || false;
        const autoplayTimeout = $(this).data('autoplay-timeout') || 5000;
        const $slider = $billboard.find('[js-billboard-list]');
        const $sliderNav = $billboard.find('[js-billboard-nav]');
        const $sliderDots = $billboard.find('[js-billboard-dot]');





        $slider.addClass('owl-carousel').owlCarousel({
            loop: false,
            nav: false,
            dots: false,
            navContainer: $sliderNav,
            autoplay: autoplay,
            autoplayTimeout: autoplayTimeout,
            autoplayHoverPause: true,
            navText: [],
            items: 1,
            onInitialized() {
                $billboard.addClass('is-init')
            },
            onChange() {
                $slider.addClass('is-lock')
            },
            onChanged() {
                $slider.removeClass('is-lock')
            }
        });


        $sliderDots.on('click', function () {
            $slider.trigger('to.owl.carousel', $(this).data('pos'));
        });
    })
})
